import { Controller } from '@hotwired/stimulus';

// Habilitations d'un technicien : ligne neuve depuis le
// modèle (Retirer l'enlève), ligne enregistrée archivée ou supprimée
// (marqueur posé, ligne masquée : form-check l'ignore), renouvelée
// (échéance = aujourd'hui + validité du type, date locale) ; un type sans
// niveau impose « Aucun » (bloc inactif), le changement vers un type avec
// niveau le vide. `validity` : années par type ; `unleveled` : types sans
// niveau.
export default class extends Controller {
    static targets = ['rows', 'template', 'row', 'level'];
    static values = { validity: Object, unleveled: Array };

    rowTargetConnected(row) {
        this.applyLevel(row);
    }

    add() {
        const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, String(Date.now()));
        this.rowsTarget.insertAdjacentHTML('beforeend', html);
    }

    remove({ currentTarget }) {
        currentTarget.closest('[data-certifications-target="row"]').remove();
    }

    archive({ currentTarget }) {
        this.flag(currentTarget, 'archived');
    }

    destroy({ currentTarget }) {
        this.flag(currentTarget, '_destroy');
    }

    renew({ currentTarget }) {
        this.setExpiry(this.row(currentTarget));
    }

    changeType({ currentTarget }) {
        const row = this.row(currentTarget);
        this.setExpiry(row);
        this.applyLevel(row, { reset: true });
    }

    flag(button, field) {
        const row = this.row(button);
        row.querySelector(`input[type="hidden"][name$="[${field}]"]`).value = 'true';
        row.hidden = true;
    }

    setExpiry(row) {
        const years = this.validityValue[this.type(row)];
        if (!years) return;
        const date = new Date();
        date.setFullYear(date.getFullYear() + years);
        const day = (value) => String(value).padStart(2, '0');
        row.querySelector('input[type="date"]').value = `${date.getFullYear()}-${day(date.getMonth() + 1)}-${day(date.getDate())}`;
    }

    applyLevel(row, { reset = false } = {}) {
        const block = row.querySelector('[data-certifications-target="level"]');
        const unleveled = this.unleveledValue.includes(Number(this.type(row)));
        block.inert = unleveled;
        block.classList.toggle('opacity-60', unleveled);
        const select = block.querySelector('select');
        if (unleveled) {
            select.value = '0';
        } else if (reset && select.value === '0') {
            select.value = '';
        } else {
            return;
        }
        select.dispatchEvent(new CustomEvent('combobox:render', { bubbles: true }));
    }

    type(row) {
        return row.querySelector('select[name$="[certification_type]"]')?.value || row.dataset.certificationType;
    }

    row(element) {
        return element.closest('[data-certifications-target="row"]');
    }
}
